import {Link} from "react-router-dom";
import { motion } from "framer-motion"

function Cpa() {
    return (
        <>
            {/* <!-- banner --> */}
            <div className="banner">
                <motion.div
                        initial={{ opacity: 0, x:-100 }}
                        whileInView={{ opacity: 1, x:0 }}
                        transition={{
                        delay: 0.4,
                        default: { ease: "linear" },
                        }}>
                    <img src="./cpaImg/CPA.jpg" alt=""/>
                </motion.div>
                <div className="cpabannertext dis">
                    Becker<br/>
                    CPA<br/>
                    <div className="fs-1 dis">
                        Exam Review
                    </div>
                </div>
            </div>
            {/* <!-- Service Nav--> */}
            <div className="servicenavbar">
                {/* style="background-color: #2B418E;" */}
                <Link to="../cpa"><div className="servicesq">CPA</div></Link>
                <Link to="../cma"><div className="servicesq">CMA</div></Link>
                <Link to="../csu"><div className="servicesq">CPA<div className="secsub">學分班</div></div></Link>
                <Link to="../service"><div className="servicesq">CPA<div className="secsub">中文加值服務</div></div></Link>
            </div>
            <div className="container-fluid mb100 text-center">
                <img src="./csuImg/csu.jpg" alt=""/>
            </div>
            {/* <!-- USCPA 有助生涯&職涯規劃 --> */}
            <div className="container mb100 mt100">
                <div className="br mt100 mb100"></div>
                <div className="beckertitlename mb100 mt100">The Bridging Program 美國會計師學分班介紹</div>
                <div className="container-fluid mb100">
                    <div className="video-xl text-center">
                        <iframe width="800" height="400" src="https://www.youtube.com/embed/B58AH08YCWA?si=CuYLFBy3XbYYvQVE" title="YouTube video player" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                    </div>
                </div>
                {/* <!-- 四科考試架構及考試注意事項 --> */}
                <div className="w-75 m-auto">
                <p><strong>學員心得</strong></p>
                前期學分班學員已發表心得！<br/>

                「價格不算太高，但能節省非常大量的時間，從半年變成幾周就能解決，所以就馬上聯繫Becker的櫃檯人員。」<br/>

                「學分班才有的最後 Simulation 解題總複習，我認為對赴美考前衝刺還不錯。」<br/>

                「跟著老師的課程複習講解，真的能省下好幾天的時間。祝福大家考照順利，學分趕快補一補，開始上工！」<br/>
                </div>
                <div className="w-75 mx-auto mt100">
                <p><strong>適用族群</strong></p>

                英澳加學歷者、綠卡移民、跨科系、四大上班族等，尚缺學分以報考美國會計師考試、需短時間補修完畢者。<br/>
                </div>

                <div className="w-75 mx-auto mt100">
                    <p><strong>修課優勢</strong></p>

                    <p><strong>省錢上萬、省力二合一、省時一年：</strong></p>
                    <ul>
                        <li>在台修讀美國學分，與美國本校相比，學費省一半</li>
                        <li>上完 Becker CPA 考試補習課程，不需再另花時間補學分</li>
                        <li>省下近一整年在校修課學分量</li>
                        <li>所得學分可直接使用報名美國會計師考試，免學歷認證費用與等待時間</li>
                        <li>購買 Becker 準備考試時，即會使用&nbsp;Becker CPA 中文課程，省去額外另修學分的時間與交通成本<br /></li>
                    </ul>
                    <span className="mt-3"><strong>全新課程製作審核完畢，2025年1月起回歸開課！</strong></span>
                </div>

                <div className="w-75 mx-auto mt100">
                    <p>每學期課程依照當下 U.S. CPA 考試範圍設計。因應近年考試改制、課程內容大幅改變，新年度學分班內容已經過學校再次嚴格審核與批准，爾後授予修畢者學分證明，<strong><span>2025年1月正式重啟，全新開班！</span></strong></p>
                    <p><strong>開課單位</strong></p>
                    <p>Becker Taiwan (捷進顧問) 與加州州立大學東灣分校 (California State University, East Bay) 合作開設。</p>
                </div>
                <div className="container">
                    <div className="table-responsive">
                        <table className="table table-bordered table-striped align-middle">
                        <thead className="table-dark text-center">
                            <tr>
                            <th>學分課程代碼</th>
                            <th>課程名稱與教學範圍</th>
                            <th>適用 Becker CPA 教材範圍</th>
                            <th>學分種類</th>
                            <th>學分數量</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                            <td>ACCT 811c</td>
                            <td>
                                <strong>Financial Accounting and Reporting I<br />財務會計與報告一</strong><br />
                                此門課的學習目標是提供企業財務會計與報告框架的知識與技能，以美國註冊會計師（US CPA）必須掌握的程度為準。<br />
                                課程內容包括概念框架、財務報告、財務報表及揭露事項。<br />
                                <em>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。<br />修課條件：無。</em>
                            </td>
                            <td>FAR 1-2</td>
                            <td>會計類</td>
                            <td>3</td>
                            </tr>
                            <tr>
                            <td>ACCT 812c</td>
                            <td>
                                <strong>Financial Accounting and Reporting II<br />財務會計與報告二</strong><br />
                                此門課的學習目標是提供企業財務會計與報告框架的知識與技能，以美國註冊會計師（US CPA）必須掌握的程度為準。<br />
                                課程內容包括貨幣性資產、存貨、土地廠房及設備、無形資產、投資、企業合併及商譽。<br />
                                <em>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。<br />修課條件：無。</em>
                            </td>
                            <td>FAR 3-4</td>
                            <td>會計類</td>
                            <td>3</td>
                            </tr>
                            <tr>
                            <td>ACCT 813c</td>
                            <td>
                                <strong>Financial Accounting and Reporting III<br />財務會計與報告三</strong><br />
                                此門課的學習目標是提供企業財務會計與報告框架的知識與技能，以美國註冊會計師（US CPA）必須掌握的程度為準。<br />
                                課程內容包括投資、現金流量表、所得稅、非營利組織會計及政府會計。<br />
                                <em>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。<br />修課條件：無。</em>
                            </td>
                            <td>FAR 5-6</td>
                            <td>會計類</td>
                            <td>3</td>
                            </tr>
                            <tr>
                            <td>ACCT 816c</td>
                            <td>
                                <strong>Auditing & Attestation I<br />審計與鑑證一</strong><br />
                                此門課的學習目標是提供美國註冊會計師在執行對公開及非公開公司之審計業務時，必須具備的知識與技能。<br />
                                課程內容包括審計報告、專業標準、審計業務、審計意見、品質控制、審計規劃及內部控制。<br />
                                <em>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。<br />修課條件：無。</em>
                            </td>
                            <td>AUD 1-2</td>
                            <td>會計類</td>
                            <td>3</td>
                            </tr>
                            <tr>
                            <td>ACCT 817c</td>
                            <td>
                                <strong>Auditing & Attestation II<br />審計與鑑證二</strong><br />
                                此門課的學習目標是提供美國註冊會計師在執行對公開及非公開公司之審計業務時，必須具備的知識與技能。<br />
                                課程內容包括舞弊、審計與業務風險、證據、抽樣、執行進一步程序、形成結論及溝通。<br />
                                <em>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。<br />修課條件：無。</em>
                            </td>
                            <td>AUD 3-4</td>
                            <td>會計類</td>
                            <td>3</td>
                            </tr>
                            <tr>
                            <td>ACCT 818c</td>
                            <td>
                                <strong>Auditing & Attestation III<br />審計與鑑證三</strong><br />
                                此門課的學習目標是提供美國註冊會計師在執行對公開及非公開公司之審計業務時，必須具備的知識與技能。<br />
                                課程內容包括整合性審計、查證業務、合規性、政府審計、會計及審閱服務、中期審閱、倫理及專業責任。<br />
                                <em>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。<br />修課條件：無。</em>
                            </td>
                            <td>AUD 5-6</td>
                            <td>會計類</td>
                            <td>3</td>
                            </tr>
                            <tr>
                            <td>ACCT 819c</td>
                            <td>
                                <strong>Federal Income Taxation I - Individuals<br />聯邦所得稅一：個人</strong><br />
                                提供 CPA 必須掌握的聯邦個人稅務知識。課程包括申報要求、總收入、調整、列舉扣除、稅額計算、財產稅務。<br />
                                <em>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。<br />修課條件：無。</em>
                            </td>
                            <td>REG 1-2</td>
                            <td>會計類</td>
                            <td>3</td>
                            </tr>
                            <tr>
                            <td>ACCT 820c</td>
                            <td>
                                <strong>Federal Income Taxation II - Entities<br />聯邦所得稅二：企業</strong><br />
                                課程涵蓋公司與通過實體課稅、多管轄區稅務、信託與遺產、贈與、免稅組織與稅務程序。<br />
                                <em>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。<br />修課條件：無。</em>
                            </td>
                            <td>REG 3-4</td>
                            <td>會計類</td>
                            <td>3</td>
                            </tr>
                            <tr>
                            <td>ACCT 821c</td>
                            <td>
                                <strong>Business Law<br />美國商事法</strong><br />
                                提供 CPA 所需美國商法知識。內容含代理、契約、保證、擔保交易、破產、證券法、聯邦法規與商業架構。<br />
                                <em>此課程無法抵免 CSUEB 會計學位課程中的同類必修學分。<br />修課條件：無。</em>
                            </td>
                            <td>REG 5-6</td>
                            <td>商業類</td>
                            <td>3</td>
                            </tr>
                            <tr className="table-secondary fw-bold">
                            <td colSpan="4" className="text-end">商業類學分數總計</td>
                            <td>3</td>
                            </tr>
                            <tr className="table-secondary fw-bold">
                            <td colSpan="4" className="text-end">會計類學分數總計</td>
                            <td>24</td>
                            </tr>
                            <tr className="table-secondary fw-bold">
                            <td colSpan="4" className="text-end">全部學分數總計</td>
                            <td>27</td>
                            </tr>
                        </tbody>
                        </table>
                    </div>
                </div>
                    預告：除了上述項目，2025 年暑假將另增加 3 門商業分析、稅務、資訊科技學分項目，待校方完成審核後公告。
                <div className="w-75 mx-auto mt100">
                    <p><strong>課表</strong></p>
                    <a href="https://drive.google.com/file/d/1pNgM1QJomDarKomeVbbj9cDv7MiUq1ab/view"><span>2025上半年度面授課表日期</span></a>
                    選擇雲端（隨選隨看影片，不參加面授）學員，亦可觀看中文雲端課程完成上課學習。
                </div>
                <div className="w-75 mx-auto mt100">
                <p><strong>上課方式（中＋英模式）</strong></p>

                    首先，以實體面授上課或雲端隨選隨看（二選一）方式參加 Becker Taiwan 台灣講師教授的中文課程，每堂課為3小時；<br/>
                    課前或課後，請搭配觀看 Becker CPA Exam Review 軟體上、相關單元範圍的美籍講師教學影片。
                </div>

                <div className="w-75 mx-auto mt100">
                    <p><strong>評量方式</strong></p>
                    首每門學分班，及格與計分方式：<br/>
                    <ul>
                        <li>完成 Becker Taiwan 中文課程 (每堂3小時＋美籍講師影片）</li>
                        <li>學員本人 Becker CPA Exam Review 軟體上，該門課程單元範圍之：
                        <ul>
                            <li>單選題 (MCQ)，完成百分比將被採計為 25% 之學分班成績</li>
                            <li>單選題 (MCQ)，已完成題目之答題正確率將被採計為 25% 之學分班成績</li>
                        </ul>
                        </li>
                        <li>參加線上期末考，答題正確率將被採計為 50% 之學分班成績
                        <ul>
                            <li>期末考為24~42題之單選題 (MCQ)，以及1~3題之情境模擬題 (Simulation)</li>
                        </ul>
                        </li>
                        <li>以上學分班成績項目加總，得分百分比達 60% 以上為及格</li>
                    </ul>
                    以上為學分班評量準則；請留意不同學分項目可能存在微幅差異，請依各門課程大綱敘述為準。<br />
                </div>

                <div className="w-75 mx-auto mt100">
                    
                    <p><strong>期末考試</strong></p>
                    每門學分班之期末考限時&nbsp;120 分鐘，提供兩種應考方式（二選一）：<br/>
                    <ul>
                        <li><strong>線上考</strong>，需預約，US$20.00，於 <a href="https://examroom.ai/">ExamRoom.ai</a>&nbsp;線上考試平台進行。</li>
                        <li><strong>實體考</strong>，需預約，免費，於 Becker Taiwan 台北大安教室進行。</li>
                    </ul>
                    以上為學分班評量準則；請留意不同學分項目可能存在微幅差異，請依各門課程大綱敘述為準。<br />
                </div>

                <div className="w-75 mx-auto mt100">
                <p><strong>選課身份</strong></p>

                    Becker Taiwan 效期內並有中文課程使用額度之學員，可進一步報名參加此學分班，及格後取得加州州立大學東灣分校開立之學分證明。<br/>
                </div>

                

                <div className="w-75 mx-auto mt100">
                <p><strong>學分費用</strong></p>
                    每門3學分之學分班，定價：新台幣 30,000 元<br/>
                    {/* 限時團報：2024年12月31日前，個人或揪團報名學分班滿 3 門課，可享每門課減免新台幣 10,000 元之優惠。<br/> */}

                </div>

                <div className="w-75 mx-auto mt100">
                <p><strong>報名方式</strong></p>
                    閱讀並填寫「<a href="https://forms.gle/W8b1QBjMxHoDWcHv9">合作學分班報名表</a>」，並完成匯款後，送出報名表單。我們在收到完整資訊與款項時，將開立發票並通知您確認選課成功。
                </div>

                <div className="w-75 mx-auto mt100">
                <p><strong>限時團報，活動條款</strong></p>
                    <ul>
                        <li>揪團報名學分班者，需相繼於 7 日內完成學分班之報名清款，團報條件方可成立。</li>
                        <li>團報條件成立後，若有後續臨時退出並導致團報條件不成立者（低於三門課），剩餘報名學分班須補足優惠差額。</li>
                        <li>優惠期限為即日起至 2024 年 12 月 31&nbsp;日&nbsp;23:59。</li>
                        <li>在適⽤法律允許的範圍內，Becker Taiwan 保留不經通知即變更本促銷活動的條款與細則， 或是在任何時候不經通知即變更或結束本促銷活動的權利。</li>
                    </ul>
                </div>


            </div>
        </>
    );
}
export default Cpa;